import moment from "moment";

export const formatearMinutos = (minutos) => {
  if (minutos === null || minutos === undefined || isNaN(minutos)) return "—";
  const total = Math.round(Math.abs(minutos));
  const signo = minutos < 0 ? "-" : "";
  if (total === 0) return "0m";
  const dias = Math.floor(total / 1440);
  const horas = Math.floor((total % 1440) / 60);
  const mins = total % 60;
  return (
    signo +
    [dias ? `${dias}d` : null, horas ? `${horas}h` : null, mins ? `${mins}m` : null].filter(Boolean).join(" ")
  );
};

export const formatearFechaHora = (fecha) => (fecha ? moment(fecha).format("ddd DD/MM HH:mm") : "—");

export const formatearHora = (fecha) => (fecha ? moment(fecha).format("HH:mm") : "—");

export const estiloBarraFiltros = {
  backgroundColor: "white",
  padding: "12px 20px",
  border: "1px solid rgb(235, 237, 240)",
  borderRadius: 12,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
  marginBottom: 10,
  display: "flex",
  alignItems: "center",
  gap: 12,
  flexWrap: "wrap",
};

export const esHoras = (unidad) => unidad === "horas";

export const etiquetaUnidadTiempo = (unidad) => (esHoras(unidad) ? "h" : "min");

export const minutosAUnidad = (minutos, unidad) => {
  if (minutos === null || minutos === undefined || minutos === "") return minutos;
  return esHoras(unidad) ? Math.round((Number(minutos) / 60) * 10000) / 10000 : Number(minutos);
};

export const unidadAMinutos = (valor, unidad) => {
  if (valor === null || valor === undefined || valor === "") return valor;
  return esHoras(unidad) ? Math.round(Number(valor) * 60 * 100) / 100 : Number(valor);
};

export const formatearTiempoCiclo = (minutos, unidad) => {
  if (minutos === null || minutos === undefined || minutos === "" || isNaN(minutos)) return "—";
  const valor = Number(minutosAUnidad(Number(minutos), unidad));
  return `${valor.toLocaleString("es-MX", { maximumFractionDigits: 4 })} ${etiquetaUnidadTiempo(unidad)}`;
};

export const formatearTiempo = (minutos, unidad) => {
  if (!esHoras(unidad)) return formatearMinutos(minutos);
  if (minutos === null || minutos === undefined || isNaN(minutos)) return "—";
  const horas = Math.round((Number(minutos) / 60) * 100) / 100;
  return `${horas.toLocaleString("es-MX", { maximumFractionDigits: 2 })} h`;
};
